<template>
    <n-dialog v-model:visible="visible">
        <div class="delete-content" :class="{'desktop-delete-content': isDesktop}" v-if="mode == 0">
            <div class="delete-content-sub_title">
                {{ paramsFile.length > 1 ? $t('account_translate_delete_dialog_title') : $t('account_enterprise_delete_dialog_title') }}
            </div>
            <div class="delete-content-button">
                <div class="delete-content-button-item_cancel" @click="handleCancel">
                    <div class="delete-content-button-item_cancel_text">
                        {{ $t('accountLoginOutBtn1') }}
                    </div>
                </div>
                <div class="delete-content-button-item_confirm" @click="handleDelete">
                    <div class="delete-content-button-item_confirm_text">
                        {{ $t('accountLoginOutBtn2') }}
                    </div>
                </div>
            </div>
        </div>
    </n-dialog>
</template>

<script setup lang="ts">
import useUserStore, { useUserStoreHook } from '~/store/modules/user'
import PDFInput from "@/components/Index/components/input/PDFInput.vue"
import { type FileItem } from '~/services/AccountServer/types'
import AccountServer from '~/services/AccountServer'
import { NetCode } from '~/types/const'
import EventBus from 'vue3-eventbus'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import Toast from '~/utils/toast'
const userStore = useUserStore()
const { userInfo } = storeToRefs(userStore)
const {t} = useI18n()
let call = defineEmits(["onDelete"])
const viewport = useViewport()
const isDesktop = computed(() => viewport.breakpoint?.value.includes('desktop'))
const visible = ref(false)
const mode = ref(0)  // 0 删除
const paramsFile = ref<FileItem[]>([])

const handleDelete = ()=>{
    console.log('删除文件', paramsFile.value)
    if (paramsFile.value.length > 1) {
        let ids = paramsFile.value.map(item => item.id).join(',')
        AccountServer.deleteFiles({
            deleteIds: ids
        }).then((res)=>{
            console.log(res)
            if(res.code === NetCode.SUCCESS){
                call('onDelete')
                visible.value = false
                Toast(t('delete_success'))
            }
        })
    }else if (paramsFile.value.length == 1) {
        AccountServer.deleteFile({
            thisId: paramsFile.value[0].id
        }).then((res)=>{
            console.log(res)
            if(res.code === NetCode.SUCCESS){
                call('onDelete')
                visible.value = false
                Toast(t('delete_success'))
            }else {
                Toast(res.message)
            }
        })
    }

}

const handleCancel = ()=>{
    console.log('取消')
    visible.value = false
}

const open = (type: number, param?: FileItem, params?: FileItem[]) =>{
    mode.value = type
    visible.value = true
    console.log('param===', param, params)
    if (param) {
        paramsFile.value.push(param)
    }
    if (params) {
        paramsFile.value = params
    }
}

onMounted(()=>{
    
})
defineExpose({
    open
})
</script>

<style lang="scss" scoped>
.desktop-delete-content{
    width: 400px;
    height: 156px;
    padding: 24px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
    .delete-content-title {
        font-size: 16px;
        font-weight: bold;
        color: #262626;
        margin-top: 16px;
    }
    .delete-content-sub_title {
        font-size: 14px;
        color: #262626;
        margin-top: 16px;
    }
    .delete-content-input {
        margin-top: 20px;
        width: 100%;
    }
    .delete-content-button {
        margin-top: 30px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        gap: 10px;
        .delete-content-button-item_cancel {
            width: 50%;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #fff;
            border: 1px solid #2590E1;
            border-radius: 4px;
            cursor: pointer;
            .create-content-button-item_cancel_text {
                font-size: 14px;
                color: #2590E1;
            }
            &:hover {
                opacity: 0.7;
            }
        }
        .delete-content-button-item_confirm {
            width: 50%;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #2590E1;
            border-radius: 4px;
            cursor: pointer;
            .delete-content-button-item_confirm_text {
                font-size: 14px;
                color: #fff;
            }
            &:hover {
                opacity: 0.7;
            }
        }
    }
}
</style>

<style scoped>

.custom-select :deep(.el-select__wrapper){
    box-shadow: none !important;
    padding: 8px 20px !important;
    min-height: 42px !important;
    box-shadow: 0 0 0 1px #BFBFBF inset !important;

}
</style>